import { css } from "@emotion/react";

export const root = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  justify-content: center;
`;

export const content = css`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  gap: 10px;
`;
